export default function utmParams() {
  if (!window) {
    return {};
  }

  const params = new URL(document.location).searchParams;

  return {
    term: params.get('utm_term'),
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    content: params.get('utm_content'),
    campaign: params.get('utm_campaign'),
  };
}
